module.exports = __webpack_public_path__ + "static/img/img1.7eed32b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/img1.png
// module id = lZim
// module chunks = 0